/**
 * Tiny claimable-quest count pill, mirroring NotificationBell's unread badge
 * (bg-rum-500 — rum-600 is absent from tailwind.config and renders transparent;
 * 9+ cap, hidden when 0). Dumb on purpose — count in, pill out — so it's
 * trivially unit-testable while AppLayout owns the data wiring.
 *
 * Two placements. The default pins the pill to a positioned ancestor's corner
 * (desktop nav). `inline` puts it in the flow, right after the label, for the
 * mobile menu row: that row is not `relative`, so an absolute pill would anchor
 * to the header instead. The inline pill is aria-hidden so it stays out of the
 * link's accessible name (otherwise "Taverne" becomes "Taverne 2"); labelling it
 * properly for screen readers is a separate accessibility pass.
 */
export function QuestNavBadge({ count, inline = false }: { count: number; inline?: boolean }) {
  if (count <= 0) return null
  const placement = inline ? 'ml-1 inline-grid align-middle' : 'absolute -top-0.5 -right-0.5 grid'
  return (
    <span
      aria-hidden={inline ? 'true' : undefined}
      className={`${placement} min-w-[1rem] h-4 px-1 place-items-center rounded-full bg-rum-500 text-[10px] font-bold text-white`}
    >
      {count > 9 ? '9+' : count}
    </span>
  )
}
